import { IStepRequest } from "./job-request.model";

export class UploadBatchValidationJobRequest  implements IStepRequest {
	stepFunctionType = 'upload-batch-validation-docs' as const;
	stepParams: { uploadBatchIds: string[] };
}
